import { parseCCTroops } from "@/lib/coc/parseCCTroops";

import styles from "./ClanCastleTroops.module.css";

type Props = {
  troops: string[];
};

export default function ClanCastleTroops({ troops }: Props) {
  const parsed = parseCCTroops(troops);

  if (parsed.length === 0) return null;

  return (
    <div className={styles.wrapper}>
      {parsed.map((t) => (
        <div key={t.name} className={styles.item}>
          {t.icon && (
            <img
              src={t.icon}
              alt={t.name}
              className={styles.image}
              loading="lazy"
              decoding="async"
              width={64}
              height={64}
            />
          )}

          <span className={styles.count}>x{t.count}</span>
        </div>
      ))}
    </div>
  );
}
